module.exports = __webpack_public_path__ + "static/media/hrhf_logo.6f815104.png";